import { Col, Container, Row } from "react-bootstrap";
import { generatePath, useNavigate } from "react-router-dom";
import TableLayoutV2 from "components/TableLayoutV2";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import { useGetNotificationCategoriesQuery, useGetNotificationTemplatesQuery } from "store/services/notifications";
import { NOTIFICATION_TEMPLATES_EDIT } from "config/paths";

const categoryLabel = (category) => String(category || "").replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());

const NotificationTemplates = () => {
  const navigate = useNavigate();
  const { data, isLoading, isError } = useGetNotificationTemplatesQuery();
  const rawCategories = Array.isArray(data) ? data : data?.categories || data?.records || [];
  const categories = rawCategories.map((item) => typeof item === "string" ? { id: item, category: item } : { ...item, id: item.id || item.category || item.key || item.value, category: item.category || item.key || item.value || item.name });
  const columns = [
    {
      head: "TYPE",
      accessor: "category",
      isComponent: true,
      component: (item) => <h6 className="m-0 fw-sbold text-capitalize">{item.type_label || "--"}</h6>
    },
    {
      head: "MESSAGE",
      accessor: "message",
      isComponent: true, component: (item) => <h6 className="m-0 fw-sbold">{item.message_template || "--"}
      </h6>
    },
     {
      head: "PRIORITY",
      accessor: "priority",
      isComponent: true, component: (item) => <h6 className="m-0 text-capitalize fw-sbold">{item.priority || "--"}
      </h6>
    },
       {
      head: "CATEGORY",
      accessor: "category",
      isComponent: true, component: (item) => <h6 className="m-0 text-capitalize fw-sbold">{item.category == 'action_item' ? "Action Item"  :  item?.category}
      </h6>
    },
  ];

  return <section className="designations position-relative py-4">
    <Container fluid>
      <Row><Col lg="12" className="my-2">
        <div className="TableFilter">
          <h6 className="m-0 fw-bold main-head themeBlue">Notification Templates</h6>
        </div>
      </Col>
        <Col lg="12" className="my-2">
          <div className="table-outer">{isLoading ? <div style={{ height: "200px" }}>
            <LoadingIndicator />
          </div> : isError ?
            <ErrorComponent /> :
            <TableLayoutV2
              data={categories}
              column={columns}
              handleRowClick={(item) => navigate(generatePath(NOTIFICATION_TEMPLATES_EDIT, { id: item?.type }))} />}
          </div>
        </Col>
      </Row>
    </Container>
  </section>;
};

export default NotificationTemplates;
